export enum StoreQueryKeys {
  CITIES = "cities",
  PLANS = "plans",
}
